import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { environment } from 'src/environments/environment'
import { H2HReview, H2HReviewObjType, H2HReviewType } from '../types/review'

type CreateReviewBody = {
  objId: string
  reviewType: H2HReviewType
  objType: H2HReviewObjType
}

type SearchReviewBody = {
  objId?: string
  reviewType?: H2HReviewType
  objType?: H2HReviewObjType
  creatorUuid?: string
}

@Injectable({
  providedIn: 'root',
})
export class ReviewService {
  private API_BASE_URL = environment.apiBaseUrl
  private http = inject(HttpClient)

  createReview(body: CreateReviewBody) {
    return this.http.post<H2HReview>(`${this.API_BASE_URL}/review`, body)
  }

  deleteReview(reviewId: string) {
    return this.http.delete(`${this.API_BASE_URL}/review/${reviewId}`)
  }

  searchReviews(body: SearchReviewBody) {
    return this.http.post<H2HReview[]>(
      `${this.API_BASE_URL}/review/search`,
      body,
    )
  }
}
